import React, { Component } from 'react';
import styled from 'styled-components';

import { CATEGORY } from './shared/data';
import Header from './shared/header';
import Content from './shared/content';
import Footer from './shared/footer';

const GalleryWrap = styled.div`
  color: #6c718b;

  font-size: 14px;
  font-family: 'Roboto', sans-serif;

  text-align: left;
  margin-top: 58px;
`;

class Gallery extends Component {
  constructor(props) {
    super(props);

    const { blogData } = this.props;

    this.state = {
      activeCategory: 'all',
      categories: [...CATEGORY],
      blogs: [...blogData.map((blog) => blog)],
      searchedValue: '',
    };
  }

  changeCategory = (categoryType) => {
    this.setState({ activeCategory: categoryType });
  };

  setSearchedValue = (value) => {
    this.setState({ searchedValue: value.toLowerCase() });
  };

  render() {
    const { activeCategory, categories, blogs, searchedValue } = this.state;

    return (
      <GalleryWrap>
        <Header blog={blogs} />
        <Content
          activeCategory={activeCategory}
          categories={categories}
          changeCategory={this.changeCategory}
          blogs={blogs}
          searchedValue={searchedValue}
          setSearchedValue={this.setSearchedValue}
        />
        <Footer blogs={blogs} />
      </GalleryWrap>
    );
  }
}

export default Gallery;
